// Retour sensoriel doux au moment où le papillon s'envole.
// Son synthétisé via Web Audio (aucun fichier audio) + vibration légère.

import { getSettings } from "./settings";

let audioCtx = null;

function getCtx() {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!audioCtx) audioCtx = new AC();
  if (audioCtx.state === "suspended") audioCtx.resume();
  return audioCtx;
}

export function playCaughtFeedback() {
  // Respecte la préférence "Son & vibration".
  if (!getSettings().sound) return;

  // Vibration (Android/Chrome ; ignorée silencieusement sur iOS).
  try {
    if (navigator.vibrate) navigator.vibrate([10, 24, 14]);
  } catch (e) {
    /* no-op */
  }

  // Petit accord majeur ascendant : « validation » chaleureuse et agréable.
  const ctx = getCtx();
  if (!ctx) return;
  const now = ctx.currentTime;
  const notes = [523.25, 659.25, 783.99]; // Do5, Mi5, Sol5

  notes.forEach((freq, i) => {
    const t = now + i * 0.07;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine";
    osc.frequency.value = freq;
    gain.gain.setValueAtTime(0.0001, t);
    gain.gain.exponentialRampToValueAtTime(0.1, t + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.5);
    osc.connect(gain).connect(ctx.destination);
    osc.start(t);
    osc.stop(t + 0.55);
  });
}
